<template>
  <div class="yellowMark">
    <div class="mark"></div>
  </div>
</template>

<script>
export default {
  name: "yellowMark"
};
</script>

<style lang="scss" scoped>
.yellowMark {
  display: inline-block;
  .mark {
    width: 7px;
    height: 16px;
    opacity: 1;
    background: #ffd63c;
    border-radius: 0px;
  }
}
</style>
